/**
 * Custom JS
 */
jQuery(document).ready(function($) {
  // Sticky header show
  var headerHeight = $('#main-header').outerHeight(),
      packSection = $('.build-cream-six-pack-wrap');
  
  if ( packSection.length > 0 ) {
    var packSectionPos = packSection.offset().top + packSection.outerHeight();
  }
  
  var lastScrollTop = 0;
  
  $(window).scroll(function() {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop){
      // downscroll code
      $('#sticky-main-header').removeClass('show');
      $('.build-cream-six-pack-wrap').removeClass('sticky');
    } else {
      // upscroll code      

      if ( $(this).scrollTop() > headerHeight + 200 ) {
        $('#sticky-main-header').addClass('show');
      } else {
        $('#sticky-main-header').removeClass('show');
      }

      if ( !$('body').hasClass('product-new') ) {
        if ( packSection.length > 0 ) {
          if ( $(this).scrollTop() > packSectionPos ) {
            $('.build-cream-six-pack-wrap').addClass('sticky');
          } else {
            $('.build-cream-six-pack-wrap').removeClass('sticky');
          }
        }
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; 
  });
  
  // Header search expanded
  $('.search_form').on('click', function(e) {
    $(this).addClass('expanded');
    $(this).find('input[type=text]').focus();
  });
  
  $(document).on('click', 'body', function(e) {
    if ( $('.search_form.expanded').length > 0 && ! $(e.target).is('.search_form, .search_form *') ) $('.search_form').removeClass('expanded');
  });
  
  // Promotion Banner Animation
  $('.js-promo-banner').each(function (index, value){
    var $promos = $(this);
    var animationStyle = $(this).data('banner-anim');

    $promos.waypoint(function() {
      $(this.element).find(".single-banner").addClass("animated " + animationStyle);
    }, { offset: '80%' });
  });
  
  // Tags filter
  $('.filter-tag-link').on('click', function(e) {
    e.preventDefault();
    
    var $this = $(this),
        targetValue = $this.data('val');
    
    $('.filter-tag-link').removeClass('active');
    $this.addClass('active');
    
    $('select[name="tag_filter"]').val(targetValue).trigger('change');
  });
  
  // SubMen Position
  $('.main-nav-menu a.dropdown_link').each(function() {
    var $this = $(this),
        leftOffset = $this.offset().left,
        dropdownRel = $this.data('dropdown-rel'),
        parentEle = $this.parents('.main_nav'),
        dropContent = parentEle.find('.dropdown_container[data-dropdown="' + dropdownRel + '"]');
    
    dropContent.find('.dropdown').css('left', leftOffset + 'px');
  });
  
  $(window).resize(function(e) {
    $('.main-nav-menu a.dropdown_link').each(function() {
      var $this = $(this),
          leftOffset = $this.offset().left,
          dropdownRel = $this.data('dropdown-rel'),
          parentEle = $this.parents('.main_nav'),
          dropContent = parentEle.find('.dropdown_container[data-dropdown="' + dropdownRel + '"]');

      dropContent.find('.dropdown').css('left', leftOffset + 'px');
    });
  });
  
  // Mobile Menu Toggle
  $('#main-header .mobile_nav').on('click', function(e) {
    var $this = $(this),
        mobileNav = $this.parents('.main-header-wrap').find('.mobile-main-navigation');
    
    mobileNav.slideToggle(400);
  });
  
  $('#sticky-main-header .mobile_nav').on('click', function(e) {
    var $this = $(this),
        mobileNav = $this.parents('.sticky-header-inner').find('.mobile-main-navigation');
    
    mobileNav.slideToggle(400);
  });
  
  // Write Review Section Anchor
  $('.product-summary-wrap .anchor-review').on('click', function(e) {
    e.preventDefault();
    
    $('#product-acc-info a[href="#review"]').click();
    $('html,body').animate({scrollTop: $('#product-acc-info').offset().top},400);
  });
  
  // Product Review Form Customize
  $('.product-info-acc ul.tabs a[href="#review"]').on('click', function(e) {
    setTimeout(function(e) {
      var nameField = $('.stamped-form-contact .stamped-form-contact-name').clone();
      
      $('.stamped-form-contact .stamped-form-contact-name').remove();
      $('.stamped-form-contact .stamped-form-contact-email').remove();
      
      nameField.insertAfter('.stamped-form-review .stamped-form-review-rating');
      
      $('.stamped-form-review-rating .stamped-form-label').text('Your Rating *');
      $('.stamped-form-contact-name .stamped-form-label').text('Nickname *');
      $('.stamped-form-review-title .stamped-form-label').text('Title *');
      $('.stamped-form-review-body .stamped-form-label').text('Review *');
      
      $('.stamped-form-review input').removeAttr('placeholder');
    }, 400);
  });
  
  // Six Pack Add Cookie
  $('.purchase-details__buttons .add_to_pack').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $this = $(this),
        packFormWrap = $this.parents('.product_pack_form'),
        productQty = packFormWrap.find('#quantity').val(),
    	productInfoObj = packFormWrap.data('product'),
        productID = productInfoObj['id'],
        productTitle = productInfoObj['title'],
        productFeaturedImg = productInfoObj['featured_image'];
    
    var temp = Cookies.get("cookieArr");
    if ( typeof(temp) == 'undefined' ) temp = '[]';
    
    cookieArr = $.parseJSON(temp);
    
    for(var i = 0; i < productQty; i++) {
      if ( cookieArr.length == 6 ) break;
      
      cookieArr.push(
        { 'id': productID, 'title': productTitle, 'image': productFeaturedImg }
      );
    }
    
    Cookies.set('cookieArr', JSON.stringify(cookieArr), { expires: 70 });
    cookiePacks();
  });
  
  $('.pack-txt-field .clear-packs').on('click', function(e) {
    e.preventDefault();
    
    Cookies.remove('cookieArr');
    $('.build-cream-six-pack-wrap .single-pack').removeClass('added');
    $('.build-cream-six-pack-wrap .add-bag-action').removeClass('completed');
    $('.build-cream-six-pack-wrap .single-pack').removeAttr('data-key').removeAttr('data-id').removeAttr('data-title');
    $('.build-cream-six-pack-wrap .single-pack .pack-img').css('background-image', 'none');
    $('.build-cream-six-pack-wrap .single-pack input').val('');
    $('.pack-need-action .count').text(6);
  });
  
  $('.pack-content-inner .single-pack .clear-pack').on('click', function(e) {
    e.preventDefault();
    
    if (Cookies.get('cookieArr')) {
      var $this = $(this),
          singlePack = $this.parent('.single-pack'),
          packKey = singlePack.data('key'),
          packArr = $.parseJSON( Cookies.get('cookieArr') );

      $('.build-cream-six-pack-wrap .single-pack').removeClass('added');
      $('.build-cream-six-pack-wrap .single-pack').removeAttr('data-key').removeAttr('data-id').removeAttr('data-title');
      $('.build-cream-six-pack-wrap .single-pack .pack-img').css('background-image', 'none');
      $('.build-cream-six-pack-wrap .single-pack input').val('');
    
      packArr.splice(packKey, 1);
      Cookies.set('cookieArr', JSON.stringify(packArr), { expires: 70 });

      cookiePacks();
    }
  });
  
  var cookiePacks = function() {
    if (Cookies.get('cookieArr')) {
      var packArr = $.parseJSON( Cookies.get('cookieArr') ),
          packCount = $('.pack-need-action .count');

      $('.build-cream-six-pack-wrap .single-pack').removeClass('added');
      packCount.text(6-packArr.length);

      if ( packArr.length == 6 ) {
        $('.build-cream-six-pack-wrap .add-bag-action').addClass('completed');
      } else {
        $('.build-cream-six-pack-wrap .add-bag-action').removeClass('completed');
      }

      $(packArr).each(function(index, value) {
        var packEle = $('.build-cream-six-pack-wrap .single-pack').eq(index);

        packEle.addClass('added');
        packEle.attr({'data-key': index, 'data-id': value['id'], 'data-title': value['title'], 'title': value['title']});
        packEle.find('.pack-img').css('background-image', 'url("' + value['image'] + '")');
        packEle.find('input').val(value['title']);
      });
    }
  }
  
  cookiePacks();
  
  /* Cart mobile */
  $(document).on('click', '.cart_container .mini_cart', function() {
    if (window.innerWidth <= 798) {
      window.location.href = '/cart';
    }
  });
  
  /* Gift wrapping */
  $('.gift-wrapping__check').change(function() {
    /*$('.gift-note').toggleClass('gift-note--hide');*/
    
    if ($(this).prop('checked') == false) {
      $('.gift-wrapping__note').val('Gift wrapping - no');
      /*
      $('.gift-note #note').val('');
      $('.gift-note__coun #current').text('0');
      $('button#checkout').attr('disabled', false);
      */
    }
    else {
      $('.gift-wrapping__note').val('Gift wrapping - yes');
    }    
  });
  $('.gift-note textarea').keyup(function() {

    var characterCount = $(this).val().length,
       	rowCount = $(this).val().split('\n').length;
    
    var reCharacterCount = 200 - characterCount;
    var reRowCount = 8 - rowCount;

    $('.gift-note__count #characters').text(reCharacterCount);
    $('.gift-note__count #lines').text(reRowCount);
    
    if (reCharacterCount < 0 || reRowCount < 0) {
      $('.gift-note__error').removeClass('gift-note__error--hide');
      $('button#checkout').attr('disabled', true);
    }
    else {
      if (!$('.gift-note__error').hasClass('gift-note__error--hide')) {
        $('.gift-note__error').addClass('gift-note__error--hide');
        $('button#checkout').attr('disabled', false);
      }
    }
  });
  
  $(document).on('click', '.js-goto_checkout', function() {
    var form = $(this).parents('form');
    if ($('.gift-note textarea').val()) {
      var params = {
        id: 35650943189144,
        quantity: 1,
        properties: {
          "message": $('.gift-note textarea').val()
        }
      };
      $.post('/cart/update.js', {updates: {35650943189144: 0}});
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: params,
        success: function() {
          form.find('.checkout-trigger').trigger('click');
        }
      });
    }
    else {
      form.find('.checkout-trigger').trigger('click');
    }
  });
});